<template>
  <el-dialog
    :close-on-click-modal="false"
    title="优惠列表"
    custom-class="project-dialog"
    :visible.sync="ProjectListVisible"
    :lock-scroll="false"
    width="60%"
  >
    <div>
      <div class="eig-filter clearfix">
        <div class="eig-rght pa-xs">
          <el-button type="primary" @click="addclassDialog">添加优惠</el-button>
        </div>
      </div>
      <el-dialog
        append-to-body
        :close-on-click-modal="false"
        title="新增优惠项目"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        :lock-scroll="false"
        width="40%"
      >
        <el-form
          :rules="projectRules"
          ref="projectForm"
          :model="formProject"
          label-width="140px"
        >
          <el-form-item prop="money" label="项目金额：">
            <el-input-number
              v-model="formProject.money"
              controls-position="right"
              :min="0"
              :max="100000000"
              :precision="2"
            >
            </el-input-number>
            <!-- <span style="margin-left: 10px">%</span> -->
          </el-form-item>
          <!-- <el-form-item prop="discountRatio" label="打折百分比：">
            <el-input-number
              v-model="formProject.discountRatio"
              controls-position="right"
              :min="0"
              :max="100"
              :precision="2"
            >
            </el-input-number>
            <span style="margin-left: 10px">%</span>
          </el-form-item> -->
          <el-form-item label="最低成团范围：" prop="numberRange" required>
            <input-number-range
              :precision="0"
              style="width: 400px"
              v-model="formProject.numberRange"
            ></input-number-range>
          </el-form-item>
          <el-form-item prop="groupList" label="指定组别：">
            <el-select
              v-model="formProject.groupList"
              multiple
              style="width: 100%"
              placeholder="请选择组别"
            >
              <el-option
                v-for="item in options"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = !dialogVisible" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="submitForm('projectForm')"
            size="small"
            >确 认</el-button
          >
        </div>
      </el-dialog>
      <el-table ref="filterTable" :data="tableData" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column prop="money" label="项目金额">
          <template slot-scope="scope">
            {{ scope.row.money  }}
          </template>
        </el-table-column>
        <el-table-column prop="discountRatio" label="打折百分比">
          <template slot-scope="scope">
            {{ scope.row.discountRatio | parDiscountRatio() }}
          </template>
        </el-table-column>
        <el-table-column prop="numberRange" label="最低成团范围">
          <template slot-scope="scope">
            {{ scope.row.numberRange | parNumberRange() }}
          </template>
        </el-table-column>
        <el-table-column prop="groupList" label="指定组别">
          <template slot-scope="scope">
            {{ scope.row.groupList | filterGroup }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="编辑" placement="top">
              <el-button
                circle
                icon="el-icon-edit"
                size="small"
                @click="editInfo(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top">
              <el-button
                circle
                size="small"
                icon="el-icon-delete"
                @click="deleteInfo(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="ProjectListVisible = false" size="small"
        >取 消</el-button
      >
      <el-button type="primary" @click="saveProject" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import InputNumberRange from "@/components/inputNumberRange.vue";
export default {
  components: {
    InputNumberRange,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    registTime: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    ProjectListVisible(value) {
      this.$emit("update:visible", value);
    },
    visible: {
      handler(value) {
        this.ProjectListVisible = value;
      },
      immediate: true,
    },
    value: {
      handler(value) {
        this.tableData = JSON.parse(JSON.stringify(value));
      },
      immediate: true,
    },
  },
  filters: {
  
    filterGroup(groupList) {
      return groupList.join(",");
    },
  
    parDiscountRatio(value) {
      return value + "%";
    },
    parNumberRange(value) {
      return `${value[0]} ~ ${value[1]}`;
    },
    formatTime(date, separate = "/") {
      if (!date) return "";
      function formatNumber(n) {
        n = n.toString();
        return n[1] ? n : "0" + n;
      }
      date = new Date(date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return [year, month, day].map(formatNumber).join(separate);
    },
  },
  data() {
    return {
      dialogVisible: false,
      ProjectListVisible: this.visible,
      // 绑定表单数据
      formProject: {
        id: "",
        money:0,
        discountRatio: 100,
        numberRange: [],
        groupList: [],
      },
      projectRules: {
        money: [{ required: true, message: "请输入项目金额：" }],
        numberRange: [{ required: true, message: "请输入最低成团范围：" }],
      },
      tableData: [],
      // 分页
      page: {
        page_size: 5,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      // 删除博客的数据对象
      deleteObj: {
        title: "",
        id: "",
      },
      // 控制弹窗
      dialogFormVisible: false,
      isEdit: false,
    };
  },
  mounted() {},
  methods: {
    saveProject() {
      this.$emit("input", this.tableData);
      this.ProjectListVisible = false;
    },
    submitForm(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.formProject.numberRange[0] == null ||
            this.formProject.numberRange[1] == null
          ) {
            this.$message.error("请填写最低成团范围");
            return;
          }
          if (this.isEdit) {
            this.dialogVisible = false;
          } else {
            this.tableData.push({
              money:this.formProject.money,
              discountRatio: this.formProject.discountRatio,
              numberRange: this.formProject.numberRange,
              groupList: this.formProject.groupList,
            });
          }

          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteInfo(row) {
      this.tableData.splice(
        this.tableData.findIndex((item) => {
          return (item = row);
        }),
        1
      );
    },
    // 编辑
    editInfo(row) {
      this.formProject = row;
      this.isEdit = true;
      this.dialogVisible = true;
      // this.$forceUpdate()
    },
    addclassDialog() {
      this.isEdit = false;
      this.formProject = {
        id: "",
        money:0,
        discountRatio: 100,
        numberRange: [],
        groupList:[]
      };
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped></style>
